// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  storageName: '__app_lovebus_dev',
  apiUrl: 'https://dev-api.getpass.ph',
  apiUrl2: 'https://api-dev.getpass.ph',
  useServerErrorMessage: true,
  resendVerification: 180, // seconds
  locationUrl: 'https://psgc.gitlab.io/api',
  googleWebClientId:
    '932717934142-spsm22jnupiig889i179hfmj9jrnic3h.apps.googleusercontent.com',
  iosClientId: '932717934142-cntl9hqff54o054bka36mrlvdulm6bkm.apps.googleusercontent.com',
  encryptionKey: 'g3tC0m3t123',
  wssUrl: 'wss://nhy2e9zt0h.execute-api.ap-southeast-1.amazonaws.com/dev',
  awsS3Url: "https://get-pass-dev.s3-ap-southeast-1.amazonaws.com/",
  apiUrlV1: 'https://api-dev.getpass.ph',
  firebaseConfig: {
    apiKey: "AIzaSyAtTu1t2ObiHFiK3fQJXt10pMluvEArfuQ",
    authDomain: "get-pass-aws.firebaseapp.com",
    databaseURL: "https://get-pass-aws.firebaseio.com",
    projectId: "get-pass-aws",
    storageBucket: "get-pass-aws.appspot.com",
    messagingSenderId: "932717934142",
    appId: "1:932717934142:web:7df6fabeb6006b39f9836f",
    measurementId: "G-TGLF2JRKSW"
  },
  defaultOrgId: 124
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
